<template>
  <q-skeleton animation="wave" v-bind="$attrs" />
</template>
